import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../Context/Context";
import Button from "../../../Custom/Button/Button";
import sortImg from "../../../../picture/Sort.png";
import redniBrojeviImg from "../../../../picture/redniBrojevi.png";

const zaposleniMock = [
  {
    id: "1",
    redniBroj: "1",
    ime: "Mika",
    prezime: "Mikic",
    radnoMesto: "Radno mesto 1"
  },
  {
    id: "2",
    redniBroj: "2",
    ime: "Pera",
    prezime: "Peric",
    radnoMesto: "Radno mesto 2"
  },
  {
    id: "3",
    redniBroj: "3",
    ime: "Zika",
    prezime: "Zikic",
    radnoMesto: "Radno mesto 3"
  }
];

const styles = {
  cell: {
    padding: "5px",
    textAlign: "center"
  },
  smallCell: {
    width: "40px",
    textAlign: "center"
  },
  icon: {
    width: "30px",
    height: "30px"
  }
};

function Zaposleni() {
  const [zaposleni, setZaposleni] = useState([]);

  const [isCheckedSort, setIsCheckedSort] = useState(false);
  const [isCheckedRedniBrojevi, setIsCheckedRedniBrojevi] = useState(false);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isCheckedAll, setIsCheckedAll] = useState(false);

  const { selectedPoslovnaJedinica, dictionary } = useGlobalContext();

  useEffect(() => {
    if (zaposleniMock) setZaposleni(zaposleniMock);
  }, [zaposleniMock]);

  const handleCheckRedniBrojevi = () => {
    setIsCheckedRedniBrojevi((prev) => !prev);
  };
  const handleCheckSort = () => {
    setIsCheckedSort((prev) => !prev);
    if (!isCheckedSort) setZaposleni((prev) => prev.reverse());
  };

  const handleCheckRow = (id) => {
    if (checkedRows.includes(id)) {
      setCheckedRows(checkedRows.filter((r) => r !== id));
    } else {
      setCheckedRows([...checkedRows, id]);
    }
  };
  const handleCheckAll = () => {
    if (isCheckedAll) {
      setCheckedRows([]);
    } else {
      setCheckedRows(zaposleni.map((z) => z.id));
    }
    setIsCheckedAll((prev) => !prev);
  };

  return (
    <table style={{ width: "100%" }}>
      <tr>
        <th style={styles.smallCell}>
          <input
            type="checkbox"
            checked={isCheckedAll}
            onChange={handleCheckAll}
            style={{ width: "30px" }}
          />
        </th>
        <th style={{ width: "80px" }}>
          <div style={{ display: "flex" }}>
            <div onClick={handleCheckSort}>
              <Button active={isCheckedSort}>
                <img src={sortImg} style={{ width: "40px", height: "30px" }} />
              </Button>
            </div>
            <div onClick={handleCheckRedniBrojevi}>
              <Button active={isCheckedRedniBrojevi}>
                <img
                  src={redniBrojeviImg}
                  style={{ width: "40px", height: "30px" }}
                />
              </Button>
            </div>
          </div>
        </th>
        <th style={styles.cell}>{dictionary["ime"]}</th>
        <th style={styles.cell}>{dictionary["prezime"]}</th>
        <th style={styles.cell}>{dictionary["radnoMesto"]}</th>
      </tr>
      {zaposleni.map((zaposlen, index) => (
        <>
          <tr key={zaposlen.id}>
            <td style={styles.cell}>
              <input
                type="checkbox"
                checked={checkedRows.includes(zaposlen.id)}
                onChange={() => handleCheckRow(zaposlen.id)}
                style={{ width: "30px" }}
              />
            </td>
            <td
              style={{ padding: "5px" }}
            >{`${isCheckedRedniBrojevi ? zaposlen.redniBroj : index + 1}.`}</td>
            <td style={styles.cell}>{zaposlen.ime}</td>
            <td style={styles.cell}>{zaposlen.prezime}</td>
            <td style={styles.cell}>{zaposlen.radnoMesto}</td>
          </tr>
        </>
      ))}
    </table>
  );
}

export default Zaposleni;
